import { mode } from '@chakra-ui/theme-tools';

export const formStyles = {
  components: {
    Form: {
      baseStyle: {
        requiredIndicator: {
          color: 'red.600',
        },
      },
    },
    FormLabel: {
      baseStyle: (props: any) => ({
        color: mode('secondaryGray.900', 'white')(props),
        fontWeight: 'bold',
        fontSize: 'sm',
        _hover: { cursor: 'pointer' },
        ms: '10px',
      }),
    },
  },
};
